import React from 'react'
import ReactDOM from 'react-dom/server'
import Observer from 'react-intersection-observer'

export const Image = props =>
  props.lazyLoad
    ? <LazyLoadImage {...props} />
    : <div className={`${props.className}`}>
        <img {...getOriginalImageProps(props)} />
      </div>

class LazyLoadImage extends React.Component {
  imageProps = getOriginalImageProps(this.props)

  constructor(props) {
    super(props)
    this.state = { ...this.state, imageLoaded: false }
  }

  setImageLoaded = () => this.setState({ imageLoaded: true })

  getChildren = inView =>
    inView
      ? <img
          onLoad={this.setImageLoaded}
          {...filterOutClassName(this.imageProps)}
          className={'lazy-loaded-image'}
        />
      : writeNoScriptWhenNotInServer(this.imageProps)

  render() {
    return (
      <Observer
        triggerOnce={true}
        rootMargin="650px"
        className={`${this.imageProps.className} ${this.state.imageLoaded
          ? 'lazy-load-loaded'
          : 'lazy-load'}`}
      >
        {this.getChildren}
      </Observer>
    )
  }
}

const filterOutClassName = obj => filterOutFromObject(obj, 'className')

const getOriginalImageProps = props => filterOutFromObject(props, ['lazyLoad', 'tag', 'threshold'])

const writeNoScriptWhenNotInServer = props =>
  <Noscript>
    <img {...filterOutClassName(props)} className={'lazy-loaded-image'} />
  </Noscript>

const filterOutFromObject = (obj, keysToFilterOut) =>
  Object.keys(obj)
    .filter(key => !keysToFilterOut.includes(key))
    .reduce((newObj, key) => Object.assign(newObj, { [key]: obj[key] }), {})

// https://github.com/facebook/react/issues/1252
const Noscript = props => {
  const staticMarkup = ReactDOM.renderToStaticMarkup(props.children)
  return <noscript dangerouslySetInnerHTML={{ __html: staticMarkup }} />
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/image/image.js